import { render, staticRenderFns } from "./applicant.vue?vue&type=template&id=6105fb7f&"
import script from "./applicant.vue?vue&type=script&lang=js&"
export * from "./applicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports